import { render } from "./ServiceItem.vue?vue&type=template&id=07acff81"
import script from "./ServiceItem.vue?vue&type=script&lang=ts"
export * from "./ServiceItem.vue?vue&type=script&lang=ts"

import "./ServiceItem.vue?vue&type=style&index=0&id=07acff81&lang=css"
script.render = render

export default script